import { Stack } from "@mui/material";
import Draggable from "@assets/icons/new/draggable.svg?react";
import { Text } from "@flat-ui";

interface Props {
  /** Name of the header */
  title: string;
}

/**
 * Renders a table column header with a draggable icon aligned to the right.
 * The icon is intended to be used as a drag handle for column reordering.
 */
export function TableHeaderWithDraggableIcon({ title }: Props): JSX.Element {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      width="100%"
      justifyContent="space-between"
      data-testid="table-header-with-draggable-icon"
    >
      <Text variant="helpText">{title}</Text>
      <Stack
        sx={{
          display: "none",
          cursor: "grab",
        }}
        className="drag-handle"
        aria-label="Reorder column"
      >
        <Draggable />
      </Stack>
    </Stack>
  );
}